const EXPIRATION_TIME_KEY = 'reg-expiration-time';
const EMAIL_CODE_KEY = 'reg-email-code';
const PERSONAL_DATA_KEY = 'reg-personal-data';


export function saveExpirationTime(value) {
  const data = localStorage.getItem(EXPIRATION_TIME_KEY);
  let newData;

  if (!data) {
    newData = [value];
  } else {
    newData = JSON.parse(data);

    newData = newData.filter(
      item => item.email !== value.email,
    );
    newData.push(value);
  }

  localStorage.setItem(EXPIRATION_TIME_KEY, JSON.stringify(newData));
}

export function getLast() {
  const data = localStorage.getItem(EXPIRATION_TIME_KEY);

  if (!data) {
    return null;
  }

  const formattedData = JSON.parse(data);

  return formattedData[formattedData.length - 1];
}

export function getLastByEmail(email) {
  const data = localStorage.getItem(EXPIRATION_TIME_KEY);

  if (!data || !email) {
    return null;
  }

  return JSON.parse(data)
    .reverse()
    .find(item => item.email === email);
}

export function getExpirationSeconds(time) {
  const timeDiff = Math.trunc((new Date(time) - new Date()) / 1000);

  return timeDiff < 0 ? 0 : timeDiff;
}

export function addMinutesToDate(date, minutes) {
  return new Date(date.getTime() + minutes * 60000);
}

export function getEmailCodeExpirationDate(expTime) {
  return addMinutesToDate(new Date(), expTime);
}

export function saveEmailCode(value) {
  localStorage.setItem(EMAIL_CODE_KEY, JSON.stringify(value));
}

export function getDataToRestore() {
  return JSON.parse(localStorage.getItem(EMAIL_CODE_KEY));
}

export function savePersonalData(data) {
  localStorage.setItem(PERSONAL_DATA_KEY, JSON.stringify(data));
}

export function getPersonalData() {
  return JSON.parse(localStorage.getItem(PERSONAL_DATA_KEY));
}

export function clearData() {
  localStorage.removeItem(EXPIRATION_TIME_KEY);
  localStorage.removeItem(EMAIL_CODE_KEY);
}

export function clearEmailCodeIfExpired() {
  const data = JSON.parse(localStorage.getItem(EMAIL_CODE_KEY));

  if (!data) {
    return;
  }

  if (!getExpirationSeconds(data.expires)) {
    localStorage.removeItem(EMAIL_CODE_KEY);
  }
}
